import { AuthService } from './../../../shared/services/auth/auth.service';

import { Component, Input, OnInit, ViewChild } from '@angular/core';
import {
  UntypedFormBuilder,
  FormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { DomSanitizer } from '@angular/platform-browser';
import { Alert, Media, UpdateAlert, UpdateState } from '@classes/alert/alert';
import { Camera, latlngConvert } from '@classes/camera/camera';
import { CameraWaste, Logs } from '@classes/logs/logs';
import {
  faCircle,
  faLink,
  faMapMarkedAlt,
  faSearch,
  faTimes,
} from '@fortawesome/free-solid-svg-icons';
import { alertService } from '@services/alert/alert.service';
import { CamerasService } from '@services/cameras/cameras.service';
import { SubscriptionBaseComponent } from 'app/shared/subscription-base/subscription-base';
import { ThumbnailComponent } from '../thumbnail/thumbnail.component';
import { VideoWasteComponent } from '../video-waste/video-waste.component';
import { mediaService } from '@services/media/media.service';
import { UserService } from '@services/user/user.service';
import * as moment from 'moment';
import { LicenseService } from '@services/anpr/license.service';

const reader = new FileReader();

interface Etat {
  value: string;
  viewValue: string;
}
interface Niveaux {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'app-smartwaste-dashboard',
  templateUrl: './smartwaste-dashboard.component.html',
  styleUrls: ['./smartwaste-dashboard.component.scss'],
})
export class SmartwasteDashboardComponent
  extends SubscriptionBaseComponent
  implements OnInit
{
  @Input() alert: Alert[];
  lat = 50.597551;
  lng = 3.403683;
  zoom = 10;
  id: any;
  logs: Logs[];
  dateDiff: number;
  camera: Camera[];
  faCircle = faCircle;
  timeCircle = faTimes;
  falink = faLink;
  isLoading = false;
  faSearch = faSearch;
  faMarker = faMapMarkedAlt;
  smartWaste: Logs[];
  choiceDateForm: UntypedFormGroup;
  today = new Date();
  // priorDate = new Date(new Date().setDate(new Date().getDate() - 30));
  choiceViewBox = ['Tous', 'Caméras', 'Alertes'];
  selectViewChoice = 'Tous';
  screenOptions = {
    position: 2,
  };

  userAppSelected: any;

  displayedColumns: string[] = [
    'date',
    'camera',
    'status',
    'etat',
    'localisation',
    'source',
    'aperçu',
  ];
  dataSource: MatTableDataSource<Alert>;

  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;

  length: number;
  pageSize = 5;
  pageSizeOptions = [5, 10, 25, 100];

  etats: Etat[] = [
    { value: 'UnTreated', viewValue: 'UnTreated' },
    { value: 'InProgress', viewValue: 'InProgress' },
    { value: 'Treated', viewValue: 'Treated' },
  ];

  niveaux: Niveaux[] = [
    { value: 'null', viewValue: 'None' },
    { value: 'Low', viewValue: 'Low' },
    { value: 'Medium', viewValue: 'Medium' },
    { value: 'High', viewValue: 'High' },
  ];

  cameras: CameraWaste[];
  alerts: Alert[];

  constructor(
    private dialog: MatDialog,
    private formBuilder: UntypedFormBuilder,
    private alertService: alertService,
    private mediaService: mediaService,
    private sanitizer: DomSanitizer,
    private cameraService: CamerasService,
    private userService: UserService,
    private authService: AuthService,
    private licenseService: LicenseService
  ) {
    super();
  }
  ngOnInit(): void {
    this.initForm();
    this.getAlerts(this.choiceDateForm.value);
    this.getCameras();

    this.userService.clientChangedSubject.subscribe(() => {
      // this.isLoading = true;

      this.getAlerts(this.choiceDateForm.value);
      this.getCameras();
    });

    this.userAppSelected = this.authService.getDecodedToken();

    if (this.userIsAdmin()) {
      this.displayedColumns.push('modifiedBy');
    }
  }
  onSubmit(changeCamera: boolean): void {
    this.getAlerts(this.choiceDateForm.value);
  }

  changeValueInputFrom(): void {
    const dateFrom = new Date(this.choiceDateForm.get('from').value).getTime();
    const dateTo = new Date(this.choiceDateForm.get('to').value).getTime();
    const niveauAlerte = this.f.niveau.value ?? null;
    const cameraAlerte = this.f.camera.value ?? null;
    const etatAlerte = this.f.etat.value ?? null;

    const date = new Date(this.choiceDateForm.get('to').value);
    date.setDate(date.getDate() - 7);

    if (dateTo <= dateFrom) {
      this.choiceDateForm.get('from').setValue(date);
    } else {
    }

    const test = this.alerts.filter((a) => {
      new Date(a.date).getTime() >= dateFrom &&
        new Date(a.date).getTime() <= dateTo &&
        a.state === etatAlerte &&
        a.camera === cameraAlerte &&
        a.status === niveauAlerte;
    });
  }

  getEtatRoute(state: any): string {
    let etat: string = '';
    switch (state) {
      case 'UnTreated':
        etat = 'components.smartwaste.history.UnTreated.label';
        break;
      case 'InProgress':
        etat = 'components.smartwaste.history.inProgress.label';
        break;
      case 'Treated':
        etat = 'components.smartwaste.history.treated.label';
        break;

      default:
        break;
    }

    return etat;
  }

  getStatusRoute(status: any): string {
    let Statut: string = '';
    switch (status) {
      case 'Low':
        Statut = 'components.smartwaste.history.Low.label';
        break;
      case 'Medium':
        Statut = 'components.smartwaste.history.Medium.label';
        break;
      case 'High':
        Statut = 'components.smartwaste.history.High.label';
        break;

      default:
        break;
    }

    return Statut;
  }

  openDialogInfoCamera(alert: Alert, index: number): void {
    const dialogRef = this.dialog.open(VideoWasteComponent, {
      data: { alert, index, length: this.dataSource.filteredData.length },
      height: '630px',
    });
  }

  openDialogThumbnail(alert: Alert, index: number): void {
    const dialogRef = this.dialog.open(ThumbnailComponent, {
      data: { alert, index, length: this.dataSource.filteredData.length },
    });
  }

  hasThumbnail(medias: Media[]): boolean {
    const check = medias.find((m) => m.type === 'Thumbnail');
    // return JSON.stringify(medias)?.includes('Thumbnail');
    return check ? true : false;
  }

  updateMarker(el): void {
    this.lat = el.location.lat;
    this.lng = el.location.lng;
    this.zoom = 17;
  }

  selectView(event) {
    this.selectViewChoice = event.value;
    // this.getLogs();
  }
  hasVideo(medias: Media[]): boolean {
    const video = medias.find((v) => v.type === 'Video');
    const check = video?.uploadSession.completedOn;
    // .find(m => m?.uploadSession?.completedOn !== null)
    if (check) {
      return true;
    } else {
      return false;
    }
  }
  haveThumbnail(medias: Media[]): Media {
    return medias.find((m) => m.type === 'Thumbnail');
  }

  get f() {
    return this.choiceDateForm.controls;
  }

  putEtat(id: string, event): void {
    const state = new UpdateState(event.value);
    this.alertService.putEtat(id, state).subscribe(() => {});
  }

  putAlertLevel(id: string, event): void {
    const status = new UpdateAlert(event.value);
    this.alertService.putAlert(id, status).subscribe(() => {});
  }

  private getCameras(): void {
    this.cameraService.getCameras().subscribe((res) => {
      this.camera = res;
      // this.choiceDateForm.get('cameraId').setValue(this.camera[0].name);
    });
  }

  private initForm(): void {
    const date = new Date();
    date.setDate(date.getDate() - 7);
    let defaultState = null;
    this.etats.map((etat) => {
      if (etat.value === 'UnTreated') {
        defaultState = etat;
      }
    });
    this.choiceDateForm = this.formBuilder.group({
      from: [date, Validators.required],
      to: [this.today, Validators.required],
      // range: new FormGroup({
      //   start: new FormControl(date, Validators.required),
      //   end: new FormControl(this.today, Validators.required),
      // }, Validators.required),
      state: [defaultState],
      level: [''],
      camera: [''],
    });
  }

  getAlerts(formValue?): void {
    this.isLoading = true;
    let filters = null;
    if (formValue) {
      filters = formValue;
    }

    this.alertService.getAlert(filters).subscribe((res) => {
      this.isLoading = false;
      res.forEach((el) => {
        const latLngSplit = (el.location as string).split(',');
        el.location = new latlngConvert(+latLngSplit[0], +latLngSplit[1]);
      });
      this.alerts = res;
      this.length = res.length;
      this.dataSource = new MatTableDataSource<Alert>(res);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
    });
  }

  getTooltip(object): string {
    let tooltip = '';

    if (object.modifiedBy) {
      tooltip +=
        'Modified by ' +
        object.modifiedBy +
        ' on ' +
        moment(object.modifiedOn).format('DD/MM/YYYY HH:mm:ss');
    }

    return tooltip;
  }

  private userIsAdmin(): boolean {
    let isAdmin = false;
    for (const r of this.userAppSelected?.role) {
      isAdmin =
        r.toLowerCase().search('superadmin') !== -1 ||
        r.toLowerCase() === 'smartwaste$admin' ||
        r.toLowerCase() === 'administration$admin'
          ? true
          : false;
      if (isAdmin) {
        break;
      }
    }

    return isAdmin;
  }
}
